var _defs, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDtFavNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "02456da16e"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "0e265c8d13"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#02456da16e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 36,
    fill: "#000000",
    y: -3,
    height: 36.000001,
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "20516e06bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.59375 0.179688 L 19.640625 0.179688 L 19.640625 20.621094 L 0.59375 20.621094 Z M 0.59375 0.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9d663d627e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 20,
    y: 0,
    height: 21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9402f6e214"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.503906 2.753906 L 25.550781 2.753906 L 25.550781 25.980469 L 4.503906 25.980469 Z M 4.503906 2.753906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "9b6111d566"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#02456da16e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 36,
    fill: "#000000",
    y: -3,
    height: 36.000001,
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d8e14cb1a9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.503906 1 L 21.550781 1 L 21.550781 23.980469 L 0.503906 23.980469 Z M 0.503906 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "60d03d62cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.503906 0.753906 L 21.550781 0.753906 L 21.550781 23.980469 L 0.503906 23.980469 Z M 0.503906 0.753906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3f7dbb7fa8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 22,
    y: 0,
    height: 24
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0576631, 0, 0, 0.0567868, 4.503755, 2.753822)",
    fillOpacity: 1,
    fill: "#01d3b5",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 208.379042 301.980731 C 192.865973 311.129533 173.559316 311.335897 157.910762 302.393459 L 111.371556 276.047662 C 95.65526 267.174012 85.900317 250.52732 85.764832 232.504869 L 85.290633 179.056606 C 85.155148 160.965366 94.63912 144.249887 110.219931 135.101085 L 156.352681 107.99862 C 171.865749 98.849818 191.104664 98.643454 206.82096 107.585892 L 253.360166 133.931689 C 269.076462 142.805339 278.831405 159.452031 278.96689 177.474482 L 279.373346 230.922745 C 279.508832 249.013985 270.02486 265.729464 254.511791 274.878266 Z M 86.645487 231.954565 C 86.780972 250.045804 96.535915 266.623708 112.252211 275.497358 L 157.843019 301.36164 C 173.559316 310.304077 192.79823 310.097713 208.379042 300.948912 L 253.631136 274.39675 C 269.144205 265.247949 278.628177 248.463681 278.492692 230.441229 L 278.086236 178.024786 C 277.95075 159.933547 268.195808 143.355643 252.479511 134.481993 L 206.82096 108.617711 C 191.172407 99.675274 171.865749 99.81285 156.352681 108.961651 L 111.100586 135.582601 C 95.587517 144.731402 86.035803 161.51567 86.239031 179.538122 Z M 86.645487 231.954565 ",
    stroke: "#01d3b5",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0e265c8d13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9d663d627e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01d3b5",
    d: "M 11.644531 18.488281 C 10.683594 19.042969 9.496094 19.050781 8.523438 18.511719 L 3.710938 15.824219 C 2.742188 15.285156 2.136719 14.273438 2.128906 13.175781 L 2.085938 7.726562 C 2.074219 6.628906 2.664062 5.609375 3.625 5.054688 L 8.390625 2.292969 C 9.351562 1.734375 10.542969 1.726562 11.511719 2.265625 L 16.328125 4.953125 C 17.296875 5.496094 17.898438 6.503906 17.90625 7.601562 L 17.953125 13.050781 C 17.960938 14.148438 17.375 15.167969 16.414062 15.726562 Z M 2.203125 13.132812 C 2.210938 14.230469 2.8125 15.242188 3.785156 15.78125 L 8.523438 18.429688 C 9.492188 18.96875 10.683594 18.960938 11.644531 18.402344 L 16.339844 15.683594 C 17.300781 15.128906 17.886719 14.109375 17.878906 13.011719 L 17.835938 7.644531 C 17.828125 6.546875 17.222656 5.535156 16.253906 4.996094 L 11.515625 2.351562 C 10.542969 1.808594 9.355469 1.816406 8.394531 2.375 L 3.695312 5.09375 C 2.734375 5.652344 2.148438 6.671875 2.15625 7.769531 Z M 2.203125 13.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#20516e06bc)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0576631, 0, 0, 0.0567868, -0.496245, -1.246178)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 210.546808 347.518376 C 193.882114 357.28627 173.288347 357.423846 156.420425 347.931104 L 72.961471 300.604972 C 56.161292 291.11223 45.661181 273.296143 45.525695 253.966719 L 44.780526 158.007483 C 44.577298 138.67806 54.806439 120.724396 71.471133 110.956503 L 154.117175 62.323399 C 170.781868 52.486717 191.443379 52.349141 208.243558 61.841883 L 291.770254 109.168015 C 308.570433 118.729545 319.002802 136.476845 319.138288 155.806268 L 319.951199 251.765504 C 320.086685 271.094927 309.925286 289.048591 293.260593 298.885272 Z M 46.812806 253.210052 C 46.948291 272.539475 57.38066 290.355562 74.248582 299.848304 L 156.420425 346.486556 C 173.220604 355.979298 193.882114 355.841722 210.546808 346.005041 L 291.973482 298.128604 C 308.638176 288.360711 318.799574 270.407047 318.664089 251.077624 L 317.91892 156.562936 C 317.783434 137.233512 307.283323 119.417425 290.483144 109.924683 L 208.3113 63.355219 C 191.443379 53.793689 170.849611 53.931265 154.184917 63.767947 L 72.690501 111.644383 C 56.025807 121.481064 45.864409 139.434728 45.999894 158.764151 Z M 46.812806 253.210052 ",
    stroke: "#01d3b5",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9402f6e214)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#9b6111d566)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4, 2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3f7dbb7fa8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d8e14cb1a9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01d3b5",
    d: "M 12.945312 22.839844 C 11.824219 23.488281 10.433594 23.5 9.304688 22.867188 L 2.800781 19.238281 C 1.667969 18.605469 0.964844 17.429688 0.957031 16.148438 L 0.894531 8.785156 C 0.886719 7.503906 1.570312 6.316406 2.691406 5.667969 L 9.132812 1.933594 C 10.253906 1.285156 11.644531 1.273438 12.773438 1.90625 L 19.277344 5.535156 C 20.410156 6.167969 21.113281 7.34375 21.121094 8.625 L 21.183594 15.988281 C 21.191406 17.269531 20.507812 18.457031 19.386719 19.105469 Z M 1.046875 16.09375 C 1.058594 17.375 1.761719 18.550781 2.894531 19.183594 L 9.304688 22.761719 C 10.433594 23.394531 11.824219 23.382812 12.945312 22.734375 L 19.292969 19.054688 C 20.414062 18.40625 21.101562 17.214844 21.089844 15.933594 L 21.03125 8.679688 C 21.019531 7.398438 20.316406 6.21875 19.183594 5.589844 L 12.773438 2.011719 C 11.644531 1.378906 10.253906 1.390625 9.132812 2.039062 L 2.785156 5.71875 C 1.664062 6.367188 0.976562 7.558594 0.988281 8.839844 Z M 1.046875 16.09375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#60d03d62cb)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0576631, 0, 0, 0.0567868, 0.503755, 0.753822)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 215.762993 388.928742 C 196.32085 400.347547 172.204464 400.553911 152.626836 389.410258 L 39.835312 325.506221 C 20.189941 314.362568 7.996263 293.657385 7.860778 271.094927 L 6.776895 141.429579 C 6.64141 118.867121 18.496375 97.955574 37.938518 86.536769 L 149.646159 20.775457 C 169.088302 9.356652 193.204688 9.150288 212.782316 20.293941 L 325.57384 84.197977 C 345.21921 95.341631 357.412889 116.046813 357.548374 138.609272 L 358.632257 268.27462 C 358.767742 290.837078 346.912777 311.748625 327.470634 323.16743 Z M 9.418859 270.131895 C 9.622087 292.694354 21.815765 313.399536 41.461136 324.54319 L 152.626836 387.552982 C 172.204464 398.696635 196.32085 398.490271 215.762993 387.071466 L 325.844811 322.273186 C 345.286953 310.854381 357.209661 289.874046 357.006433 267.311588 L 355.990293 139.572304 C 355.787065 117.009845 343.593387 96.235874 323.948016 85.161009 L 212.782316 22.151217 C 193.204688 11.007563 169.088302 11.213927 149.646159 22.632733 L 39.564341 87.431013 C 20.122199 98.849818 8.199491 119.830152 8.402719 142.392611 Z M 9.418859 270.131895 ",
    stroke: "#01d3b5",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtFavNew);
export default __webpack_public_path__ + "static/media/dtFavNew.c220d7f6bcb073c7cce786ea86d3bea2.svg";
export { ForwardRef as ReactComponent };